/* eslint-disable no-return-await */
import jwtDecode from 'jwt-decode'
import axios from 'services/axiosBase'
import { toast } from 'react-toastify'
import { history } from 'redux/store'

import env from 'config/env.json'
import { MIME_TYPES, RESPONSE_TYPE } from 'utils/constants/mimeTypes'
import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'

export const URL_VARIABLES = {
  CORE: 'core',
  ANTIFRAUDE: 'antifraude',
}

const chooseBaseUrl = (source = URL_VARIABLES.CORE) => {
  const url = env[source]

  if (process.env.REACT_APP_ENVIRONMENT === 'development') return url.local_url
  if (process.env.REACT_APP_ENVIRONMENT === 'staging') return url.staging_url
  if (process.env.REACT_APP_ENVIRONMENT === 'production')
    return url.production_url

  return url.local_url
}

export const coreUrl = chooseBaseUrl()

const service = async (
  method,
  url,
  token = false,
  data,
  params,
  source = URL_VARIABLES.CORE,
  contentType = MIME_TYPES.JSON,
  responseType = RESPONSE_TYPE.JSON,
) => {
  const baseUrl = chooseBaseUrl(source)
  const prefix = source === URL_VARIABLES.CORE ? '/api' : ''

  const location = `${window.location.pathname}${window.location.search}`

  if (!token && token !== false) {
    history.push({
      pathname: ROUTE_CONSTANTS.LOGIN,
      state: {
        from: location,
      },
    })
    history.go()
    return null
  }

  if (token !== false) {
    const decoded = jwtDecode(token)
    const current_time = Date.now() / 1000

    if (decoded.exp < current_time) {
      toast.error('Seu acesso expirou, faça login novamente.')
      history.push({
        pathname: ROUTE_CONSTANTS.LOGIN,
        state: { from: location },
      })
      history.go()
      return null
    }
  }

  const headers = {}

  if (token) {
    headers['Content-Type'] = contentType
    headers.Authorization = `Bearer ${token}`
  }

  const requestConfig = {
    method: method,
    url: `${baseUrl}${prefix}${url}`,
    headers: headers,
    crossDomain: true,
    data: data || null,
    params: params || null,
    responseType: responseType,
  }

  return await axios(requestConfig)
}

export const get = async ({ url, token, params, source, contentType, responseType }) => {
  return await service('GET', url, token, null, params, source, contentType, responseType)
}

export const post = async ({
  url,
  token,
  data,
  params,
  source,
  contentType,
  responseType,
}) => {
  return await service('POST', url, token, data, params, source, contentType, responseType)
}

export const put = async ({
  url,
  token,
  data,
  params,
  source,
  contentType,
  responseType,
}) => {
  return await service('PUT', url, token, data, params, source, contentType, responseType)
}

export const patch = async ({
  url,
  token,
  data,
  params,
  source,
  contentType,
  responseType,
}) => {
  return await service('PATCH', url, token, data, params, source, contentType, responseType)
}

export const remove = async ({
  url,
  token,
  data,
  params,
  source,
  contentType,
  responseType,
}) => {
  return await service('DELETE', url, token, data, params, source, contentType, responseType)
}
